/* TWRD variant-guard.
   Fjerner fejlen "Failed to fetch variant for options combination: ..." paa PDP.

   AARSAG (maalt 2026-09-16 mod thwrd.com):
   Temaets <variant-radios> henter en ny section-render pr. variantskift
   (Section Rendering API). Oveni prefetcher den ALLE nabo-kombinationer
   i en samlet byge, baade ved foerste visning og efter hvert skift.
   Paa dette produkt er det 5 ekstra kald pr. klik. Byger af den type bliver
   afvist af Shopifys Cloudflare-lag med HTTP 429 og headeren
   "cf-mitigated: challenge". Svaret er en challenge-side, ikke en rate limit.
   fetch() kan ikke loese en challenge, saa alle efterfoelgende kald fejler,
   ogsaa temaets tre hurtige retries. Derefter vises fejlteksten.
   Maalt: 48 samtidige kald gav 200, naeste runde gav 429 i mindst 2 minutter.

   RETTELSE (tre lag, alle uden aendring i temaets kernefil):
   1. Prefetch slaas fra. adjacentOptionValueIds defineres som tom liste,
      saa #cacheAdjacentVariants ikke sender noget. 1 kald pr. klik i stedet
      for 6. Det er det, der holder os under Cloudflares graense.
   2. Kald mod section-renderen koeres gennem en koe: ét ad gangen, mindst
      MIN_GAP_MS imellem, nyeste foerst (brugerens klik springer koeen over),
      og identiske kald deles. Et nyt skift annullerer alle aeldre skift for
      samme element, saa et forældet svar aldrig kan overskrive DOM.
   3. Fejler et kald alligevel, retries der med backoff. Er svaret en
      Cloudflare-challenge, hjaelper retries ikke. Saa slaas variant-id'et op
      lokalt i temaets egen variant-JSON, og siden navigeres til
      ?variant=<id>. En rigtig navigation loeser challengen, og brugerens valg
      bliver bevaret. Sker hoejst én gang pr. fane. */
(function () {
  'use strict';

  var MAX_CONCURRENT = 1;
  var MIN_GAP_MS = 250;
  var MAX_RETRIES = 2;
  var BACKOFF_MS = [600, 1500];
  var RELOAD_FLAG = 'twrd:variant-guard:recovered';
  var VARIANT_TAGS = 'variant-radios, variant-selects, variant-mixed-inputs';

  /* ---------- 1. prefetch fra ---------- */

  function disablePrefetch(el) {
    if (!el || el.__twrdNoPrefetch) return;
    el.__twrdNoPrefetch = true;
    try {
      Object.defineProperty(el, 'adjacentOptionValueIds', {
        configurable: true,
        get: function () {
          return [];
        },
        set: function () {
          /* Temaets updateOptions() skriver her. Vi kasserer vaerdien. */
        }
      });
    } catch (err) {
      /* Kan kun fejle hvis browseren naegter defineProperty. Guarden
         fortsaetter uden lag 1; lag 2 og 3 virker stadig. */
      el.__twrdNoPrefetch = false;
    }
  }

  function scanVariantElements(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(VARIANT_TAGS);
    for (var i = 0; i < nodes.length; i++) disablePrefetch(nodes[i]);
  }

  /* Lag 1 skal vaere paa plads FOER temaets IntersectionObserver sender
     prefetch-bygen. scanVariantElements() koerer foerst ved DOMContentLoaded
     (og 200 ms efter en DOM-aendring). Er temaets moduler i cachen, naar
     observeren at fyre foer det. Saa sendes bygen alligevel, koeen annullerer
     alle kald undtagen det sidste, og de annullerede promises bliver liggende
     i temaets variant-cache. De resolver aldrig, saa et klik paa den stoerrelse
     haenger i `await cachedVariantData`: knappen skifter, men formularens
     variant-id goer ikke. Maalt 2026-09-30 paa 2. sidevisning i samme session.

     Derfor patches klassens prototype i samme oejeblik elementet defineres.
     whenDefined() resolver som microtask lige efter temaets modul, altsaa foer
     observerens callback. En accessor paa prototypen fanger ogsaa temaets
     `this.adjacentOptionValueIds = ...` for alle senere elementer. */
  function disablePrefetchOnClass(tag) {
    if (!window.customElements || !window.customElements.whenDefined) return;
    window.customElements.whenDefined(tag).then(function () {
      var ctor = window.customElements.get(tag);
      if (ctor && ctor.prototype) {
        try {
          Object.defineProperty(ctor.prototype, 'adjacentOptionValueIds', {
            configurable: true,
            get: function () {
              return [];
            },
            set: function () {
              /* Temaets updateOptions() skriver her. Vi kasserer vaerdien. */
            }
          });
        } catch (err) {
          /* Elementerne afkobles stadig enkeltvis af scanVariantElements(). */
        }
      }
      /* Elementer der blev opgraderet inde i define() har allerede vaerdien
         som egen property. De afkobles her, foer observeren fyrer. */
      scanVariantElements(document);
    }, function () {
      /* whenDefined afviser kun ved et ugyldigt tag-navn. */
    });
  }

  /* ---------- hjaelpere ---------- */

  function isSectionRenderUrl(url) {
    if (typeof url !== 'string') return false;
    if (url.indexOf('section_id=') === -1) return false;
    if (url.indexOf('option_values=') === -1) return false;
    /* Kun samme origin. Absolutte URL'er til andre domaener skal passere. */
    if (url.indexOf('//') === -1) return true;
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch (err) {
      return false;
    }
  }

  function isChallenge(response) {
    if (!response) return false;
    var mitigated = '';
    try {
      mitigated = response.headers.get('cf-mitigated') || '';
    } catch (err) {
      mitigated = '';
    }
    if (mitigated) return true;
    return response.status === 430 || response.status === 429;
  }

  function optionValuesOf(url) {
    var match = /[?&]option_values=([^&]*)/.exec(url);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (err) {
      return match[1];
    }
  }

  /* ---------- 3. lokalt fallback-opslag af variant-id ---------- */

  function selectedOptionValues(el) {
    var out = [];
    var groups = el.querySelectorAll('fieldset, select');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (group.tagName === 'SELECT') {
        var option = group.options[group.selectedIndex];
        out.push(option ? option.value : '');
      } else {
        var checked = group.querySelector('input:checked');
        out.push(checked ? checked.value : '');
      }
    }
    return out;
  }

  function allVariantsOf(el) {
    var json = el.querySelector('[id^="all-variant-data-"]');
    if (!json) {
      var uniqueId = el.dataset.card || el.dataset.section || '';
      json = uniqueId ? document.getElementById('all-variant-data-' + uniqueId) : null;
    }
    if (!json) return [];
    try {
      var data = JSON.parse(json.textContent);
      return Array.isArray(data) ? data : [];
    } catch (err) {
      return [];
    }
  }

  function matchVariantId(el) {
    var wanted = selectedOptionValues(el);
    if (!wanted.length) return null;
    var variants = allVariantsOf(el);
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (!variant || !variant.options || variant.options.length !== wanted.length) continue;
      var hit = true;
      for (var k = 0; k < wanted.length; k++) {
        if (variant.options[k] !== wanted[k]) {
          hit = false;
          break;
        }
      }
      if (hit) return variant.id;
    }
    return null;
  }

  function alreadyRecovered() {
    try {
      return window.sessionStorage.getItem(RELOAD_FLAG) === '1';
    } catch (err) {
      return false;
    }
  }

  function markRecovered() {
    try {
      window.sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch (err) {
      /* Privat tilstand uden sessionStorage. Vi bruger da flaget i hukommelsen. */
    }
  }

  var recoverArmed = true;

  /* En navigation loeser Cloudflare-challengen og bevarer brugerens valg.
     Hoejst én gang pr. fane, saa en haard blokering ikke giver en reload-loop. */
  function recoverFromChallenge(optionValues) {
    if (!recoverArmed || alreadyRecovered()) return;
    var elements = document.querySelectorAll(VARIANT_TAGS);
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var variantId = matchVariantId(el);
      if (!variantId) continue;
      var base = el.dataset.url || window.location.pathname;
      recoverArmed = false;
      markRecovered();
      console.warn('TWRD variant-guard: Cloudflare-challenge paa', optionValues, '- genindlaeser med ?variant=' + variantId);
      window.location.assign(base + '?variant=' + variantId);
      return;
    }
  }

  /* ---------- 2. koe med pacing, dedupe, nyeste-foerst og annullering ----------

     Et variantskift skal vinde over alle aeldre skift for SAMME element.
     Uden det kan et aeldre svar lande efter det nyeste og overskrive dele
     af DOM med forældet indhold. Maalt: 6 klik med 120 ms mellemrum gav
     valgt "White / L / FRONT PRINT" men produktfakta fra BACK PRINT.

     Naar et nyt option_values-kald for samme section_id kommer ind,
     annulleres alle aeldre kald for det section_id:
     - i koeen: fjernes,
     - undervejs: afbrydes med AbortController.
     Et annulleret kald resolver ALDRIG. Temaets onVariantChange venter paa
     `await fetch(...)`, saa den paagaeldende kaldsgang parkeres og roerer
     hverken DOM eller fejlrendering. Kun det nyeste kald naar frem.
     Identiske URL'er deles stadig (dedupe). */

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!nativeFetch) return;

  var queue = [];
  var active = [];
  var inFlight = 0;
  var lastStart = 0;
  var pending = {};
  var timer = null;

  function sectionKeyOf(url) {
    var match = /[?&]section_id=([^&]*)/.exec(url);
    return match ? match[1] : '';
  }

  /* Intent prefetch (2026-10-23, C3). A size/colour chip under the pointer or
     finger is fetched before the click, through this same queue, so the
     click resolves from a finished response. Rules that keep us under the
     Cloudflare limit:
     - prefetch jobs have the lowest priority (front of the queue, the pump
       takes from the back) and never cancel a user job,
     - a user fetch cancels every prefetch for another URL,
     - a newer prefetch drops older prefetches that have not started yet,
     - no retries, at most PREFETCH_MAX per page, and the first challenge or
       error stops prefetching for the rest of the page view. */
  var PREFETCH_MAX = 12;
  var PREFETCH_DWELL_MS = 80;
  var WARM_TTL_MS = 5 * 60 * 1000;
  var WARM_MAX = 12;
  var prefetchCount = 0;
  var prefetchOff = false;
  /* url -> { response, at }. Unread, ok responses from finished prefetches. */
  var warm = {};
  var warmOrder = [];
  /* URLs the theme already fetched for real. Its own variant cache holds
     them, so a prefetch would be wasted. */
  var seen = {};

  function forget(job) {
    if (pending[job.key] === job.promise) delete pending[job.key];
  }

  function storeWarm(url, response) {
    if (warm[url]) return;
    warm[url] = { response: response, at: Date.now() };
    warmOrder.push(url);
    while (warmOrder.length > WARM_MAX) delete warm[warmOrder.shift()];
  }

  /* Hands out a warm response once. The theme caches the parsed template
     after the click, so the same URL is never asked for again. */
  function takeWarm(url) {
    var hit = warm[url];
    if (!hit) return null;
    delete warm[url];
    var index = warmOrder.indexOf(url);
    if (index !== -1) warmOrder.splice(index, 1);
    if (Date.now() - hit.at > WARM_TTL_MS) return null;
    return hit.response;
  }

  /* A user fetch reuses a prefetch job for the same URL: from now on it is a
     user job (top priority, never dropped as a prefetch). */
  function promote(url) {
    var i;
    for (i = 0; i < queue.length; i++) {
      if (queue[i].url === url && queue[i].prefetch) {
        var job = queue.splice(i, 1)[0];
        job.prefetch = false;
        queue.push(job);
        return;
      }
    }
    for (i = 0; i < active.length; i++) {
      if (active[i].url === url) active[i].prefetch = false;
    }
  }

  function cancelPrefetches(keepUrl) {
    var kept = [];
    for (var i = 0; i < queue.length; i++) {
      var queued = queue[i];
      if (queued.prefetch && queued.url !== keepUrl) cancel(queued);
      else kept.push(queued);
    }
    queue = kept;
    for (var k = 0; k < active.length; k++) {
      var running = active[k];
      if (running.prefetch && running.url !== keepUrl) cancel(running);
    }
  }

  function dropQueuedPrefetches() {
    var kept = [];
    for (var i = 0; i < queue.length; i++) {
      if (queue[i].prefetch) cancel(queue[i]);
      else kept.push(queue[i]);
    }
    queue = kept;
  }

  function userJobWaiting() {
    for (var i = 0; i < queue.length; i++) if (!queue[i].prefetch && !queue[i].cancelled) return true;
    for (var k = 0; k < active.length; k++) if (!active[k].prefetch && !active[k].cancelled) return true;
    return false;
  }

  function cancel(job) {
    job.cancelled = true;
    forget(job);
    if (job.controller) {
      try {
        job.controller.abort();
      } catch (err) {
        /* AbortController.abort() kaster ikke i praksis. Guarden maa
           alligevel ikke vaelte, hvis en polyfill goer det. */
      }
    }
  }

  /* Fjerner aeldre kald for samme <variant-radios>. keepUrl er det nye kald,
     som aldrig maa annullere sig selv (dedupe af identisk URL). */
  function cancelOlder(sectionKey, keepUrl) {
    if (!sectionKey) return;
    var kept = [];
    for (var i = 0; i < queue.length; i++) {
      var queued = queue[i];
      if (queued.section === sectionKey && queued.url !== keepUrl) cancel(queued);
      else kept.push(queued);
    }
    queue = kept;
    for (var k = 0; k < active.length; k++) {
      var running = active[k];
      if (running.section === sectionKey && running.url !== keepUrl) cancel(running);
    }
  }

  function schedule() {
    if (timer !== null) return;
    if (!queue.length || inFlight >= MAX_CONCURRENT) return;
    var wait = Math.max(0, MIN_GAP_MS - (Date.now() - lastStart));
    timer = window.setTimeout(function () {
      timer = null;
      pump();
    }, wait);
  }

  function pump() {
    if (inFlight >= MAX_CONCURRENT) return;
    /* Nyeste foerst: brugerens seneste klik skal ikke vente paa aeldre kald. */
    var job = null;
    while (queue.length && job === null) {
      var candidate = queue.pop();
      if (!candidate.cancelled) job = candidate;
    }
    if (!job) return;
    if (Date.now() - lastStart < MIN_GAP_MS) {
      queue.push(job);
      schedule();
      return;
    }
    inFlight += 1;
    active.push(job);
    lastStart = Date.now();
    run(job, 0);
  }

  function release(job) {
    inFlight -= 1;
    var index = active.indexOf(job);
    if (index !== -1) active.splice(index, 1);
    schedule();
  }

  function settle(job, value, failed) {
    release(job);
    forget(job);
    /* Et annulleret kald resolver aldrig. Temaets kaldsgang parkeres. */
    if (job.cancelled) return;
    if (failed) job.reject(value);
    else job.resolve(value);
  }

  function run(job, attempt) {
    var promise;
    if (job.cancelled) {
      release(job);
      return;
    }
    var init = job.init ? Object.assign({}, job.init) : {};
    if (window.AbortController && !init.signal) {
      job.controller = new window.AbortController();
      init.signal = job.controller.signal;
    }
    try {
      promise = nativeFetch(job.input, init);
    } catch (err) {
      settle(job, err, true);
      return;
    }
    promise.then(
      function (response) {
        if (job.cancelled) {
          release(job);
          return;
        }
        if (response.ok) {
          settle(job, response, false);
          return;
        }
        if (job.prefetch) {
          /* A failed prefetch never retries and never navigates. It stops
             all further prefetching; the click then fetches as before. */
          prefetchOff = true;
          settle(job, response, false);
          return;
        }
        if (isChallenge(response)) {
          /* Retries hjaelper ikke mod en challenge. Giv svaret videre,
             saa temaet ruller valget tilbage, og forsoeg en navigation. */
          settle(job, response, false);
          recoverFromChallenge(optionValuesOf(job.url));
          return;
        }
        if (attempt < MAX_RETRIES) {
          retry(job, attempt);
          return;
        }
        settle(job, response, false);
      },
      function (err) {
        if (job.cancelled) {
          release(job);
          return;
        }
        if (job.prefetch) {
          prefetchOff = true;
          settle(job, err, true);
          return;
        }
        if (attempt < MAX_RETRIES) {
          retry(job, attempt);
          return;
        }
        settle(job, err, true);
      }
    );
  }

  function retry(job, attempt) {
    var delay = BACKOFF_MS[attempt] || BACKOFF_MS[BACKOFF_MS.length - 1];
    window.setTimeout(function () {
      if (job.cancelled) {
        release(job);
        return;
      }
      lastStart = Date.now();
      run(job, attempt + 1);
    }, delay);
  }

  function enqueue(url, input, init) {
    var section = sectionKeyOf(url);
    seen[url] = true;
    /* Foerst annullér aeldre skift for samme element, derefter dedupe. */
    cancelOlder(section, url);
    /* A user fetch always wins over prefetches for other URLs. */
    cancelPrefetches(url);
    var ready = takeWarm(url);
    if (ready) return Promise.resolve(ready);
    var existing = pending[url];
    if (existing) {
      promote(url);
      /* Samme kald er allerede i koeen. Del svaret, hver forbruger
         skal have sin egen body. */
      return existing.then(function (response) {
        return response && response.clone ? response.clone() : response;
      });
    }
    var job = { key: url, url: url, section: section, input: input, init: init, cancelled: false, controller: null };
    job.promise = new Promise(function (resolve, reject) {
      job.resolve = resolve;
      job.reject = reject;
      queue.push(job);
    });
    pending[url] = job.promise;
    schedule();
    return job.promise.then(function (response) {
      return response && response.clone ? response.clone() : response;
    });
  }

  /* Low-priority request for a URL the theme will most likely ask for next.
     Returns nothing: the response waits in `warm` or in `pending`. */
  function prefetch(url) {
    if (prefetchOff || prefetchCount >= PREFETCH_MAX) return;
    if (seen[url] || warm[url] || pending[url]) return;
    if (userJobWaiting()) return;
    dropQueuedPrefetches();
    prefetchCount += 1;
    var job = { key: url, url: url, section: sectionKeyOf(url), input: url, init: undefined, cancelled: false, controller: null, prefetch: true };
    job.promise = new Promise(function (resolve, reject) {
      job.resolve = resolve;
      job.reject = reject;
    });
    pending[url] = job.promise;
    /* Front of the queue: pump() takes from the back, so every user job
       queued later still goes first. */
    queue.unshift(job);
    job.promise.then(function (response) {
      if (job.prefetch && response && response.ok) storeWarm(url, response);
    }, function () {});
    schedule();
  }

  window.fetch = function (input, init) {
    var url;
    try {
      url = typeof input === 'string' ? input : input && input.url;
    } catch (err) {
      url = null;
    }
    if (!isSectionRenderUrl(url)) return nativeFetch(input, init);
    try {
      return enqueue(url, input, init);
    } catch (err) {
      return nativeFetch(input, init);
    }
  };

  /* ---------- 4. variant-id med det samme (2026-10-14) ----------
     Temaet saetter input[name=id] foerst naar section-renderen er hentet
     (100-450 ms efter trykket, laengere bag koeen ovenfor). Et hurtigt tryk
     paa Add to bag kunne derfor sende den forrige stoerrelse.
     Her slaas id'et op lokalt i samme oejeblik som valget skifter
     (capture, foer temaets egen lytter). Kun value-egenskaben saettes,
     ikke attributten, saa temaets cache af section-HTML er uroert.
     Temaets svar erstatter formularen bagefter med det samme id. */
  document.addEventListener('change', function (event) {
    try {
      var target = event.target;
      if (!target || !target.closest || target.name === 'id') return;
      var el = target.closest(VARIANT_TAGS);
      if (!el) return;
      var uniqueId = el.dataset.card || el.dataset.section;
      if (!uniqueId) return;
      var id = matchVariantId(el);
      if (!id) return;
      var forms = document.querySelectorAll('#product-form-' + uniqueId + ', #product-form-installment-' + uniqueId);
      for (var i = 0; i < forms.length; i++) {
        var input = forms[i].querySelector('input[name="id"]');
        if (input && String(input.value) !== String(id)) input.value = String(id);
      }
    } catch (err) {}
  }, true);

  /* ---------- 5. intent prefetch for size and colour chips (2026-10-23) ----------
     Builds the exact URL that VariantSelects.onVariantChange() in
     variant-select-components.js builds for the hovered option, so the click
     dedupes onto the prefetch (same string) or takes its warm response.
     Nothing on screen changes: the theme renders the same response as before. */

  function radioOfLabel(label) {
    var input = label.control || null;
    if (!input && label.htmlFor) input = document.getElementById(label.htmlFor);
    if (!input && label.previousElementSibling && label.previousElementSibling.tagName === 'INPUT') {
      input = label.previousElementSibling;
    }
    return input && input.type === 'radio' ? input : null;
  }

  /* optionValueIds as the theme's updateOptions() would see them after a
     click on `input`. null when we cannot be sure. */
  function optionIdsAfter(el, input) {
    var tag = el.tagName.toLowerCase();
    var fieldset = input.closest('fieldset');
    if (!fieldset || !el.contains(fieldset)) return null;
    var ids = [];
    var swapped = false;
    var i;
    if (tag === 'variant-radios') {
      var fieldsets = el.querySelectorAll('fieldset');
      for (i = 0; i < fieldsets.length; i++) {
        if (fieldsets[i] === fieldset) {
          ids.push(input.dataset.optionValueId);
          swapped = true;
          continue;
        }
        var radios = fieldsets[i].querySelectorAll('input');
        var checked = null;
        for (var r = 0; r < radios.length && !checked; r++) if (radios[r].checked) checked = radios[r];
        ids.push(checked ? checked.dataset.optionValueId : undefined);
      }
    } else if (tag === 'variant-mixed-inputs') {
      var nodes = el.querySelectorAll('input:checked, select');
      for (i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.tagName === 'INPUT' && node.closest('fieldset') === fieldset) {
          ids.push(input.dataset.optionValueId);
          swapped = true;
        } else if (node.tagName === 'SELECT') {
          var option = node.options[node.selectedIndex];
          ids.push(option ? option.dataset.optionValueId : undefined);
        } else {
          ids.push(node.dataset.optionValueId);
        }
      }
    } else {
      return null;
    }
    if (!swapped || !ids.length) return null;
    for (i = 0; i < ids.length; i++) if (!ids[i]) return null;
    return ids;
  }

  function prefetchUrlFor(input) {
    if (!input || input.checked || input.disabled) return null;
    if (input.dataset.productUrl) return null;
    var el = input.closest(VARIANT_TAGS);
    if (!el || !el.dataset.url) return null;
    var ids = optionIdsAfter(el, input);
    if (!ids) return null;
    /* Combined listing: the theme would fetch another product URL. Skip. */
    for (var i = 0; i < ids.length; i++) {
      if (el.querySelector('[data-option-value-id="' + ids[i] + '"][data-product-url]')) return null;
    }
    var key = ids.join(',');
    var viewParams = el.dataset.viewId ? '?view=' + el.dataset.viewId : '';
    var sectionParams = el.dataset.section ? (viewParams ? '&' : '?') + 'section_id=' + el.dataset.section : '';
    var params = key ? (sectionParams || viewParams ? '&' : '?') + 'option_values=' + key : '';
    var url = el.dataset.url + viewParams + sectionParams + params;
    return isSectionRenderUrl(url) ? url : null;
  }

  function prefetchInput(input) {
    try {
      var url = prefetchUrlFor(input);
      if (url) prefetch(url);
    } catch (err) {
      /* Prefetch is an optimisation only. The click path is unchanged. */
    }
  }

  function chipLabelOf(target) {
    var label = target && target.closest ? target.closest('label') : null;
    return label && label.closest(VARIANT_TAGS) ? label : null;
  }

  var hoverLabel = null;
  var hoverTimer = null;

  function clearHover() {
    if (hoverTimer !== null) window.clearTimeout(hoverTimer);
    hoverTimer = null;
    hoverLabel = null;
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    var label = chipLabelOf(event.target);
    if (!label || label === hoverLabel) return;
    clearHover();
    hoverLabel = label;
    /* A short dwell: sweeping the pointer across the chips sends nothing. */
    hoverTimer = window.setTimeout(function () {
      hoverTimer = null;
      prefetchInput(radioOfLabel(label));
    }, PREFETCH_DWELL_MS);
  }, { passive: true });

  document.addEventListener('pointerout', function (event) {
    if (!hoverLabel) return;
    var to = event.relatedTarget;
    if (to && hoverLabel.contains(to)) return;
    clearHover();
  }, { passive: true });

  document.addEventListener('touchstart', function (event) {
    var label = chipLabelOf(event.target);
    if (label) prefetchInput(radioOfLabel(label));
  }, { passive: true, capture: true });

  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (!target || target.type !== 'radio' || !target.closest || !target.closest(VARIANT_TAGS)) return;
    prefetchInput(target);
  });

  /* ---------- opstart ---------- */

  function init() {
    scanVariantElements(document);
  }

  VARIANT_TAGS.split(', ').forEach(disablePrefetchOnClass);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) {
    scanVariantElements(event && event.target ? event.target : document);
  });
  /* Temaet udskifter <variant-radios>-indholdet og hele product-single ved
     skift mellem combined listings. Nye elementer skal ogsaa afkobles. */
  if (window.MutationObserver) {
    var rescanTimer = null;
    new MutationObserver(function () {
      if (rescanTimer !== null) return;
      rescanTimer = window.setTimeout(function () {
        rescanTimer = null;
        scanVariantElements(document);
      }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
